// Zentrale Produktdaten. Preise bewusst null ("Preis auf Anfrage"); später pro Modell/Edition ergänzbar.

export const EDITIONS = [
  {
    code: "natural",
    name: "Natural",
    label: { de: "Natural Edition", en: "Natural Edition", fr: "Natural Edition", es: "Natural Edition" },
    swatch: "linear-gradient(135deg, #E3C89F 0%, #D2AE7C 55%, #C49C68 100%)",
    hex: "#D8B282",
    backdrop: "#F3EFEA",
    dark: false,
    desc: {
      de: "Helles Naturholz – warm, ruhig und zeitlos.",
      en: "Light natural wood – warm, calm and timeless.",
      fr: "Bois naturel clair – chaleureux, calme et intemporel.",
      es: "Madera natural clara – cálida, serena y atemporal.",
    },
  },
  {
    code: "walnut",
    name: "Walnut",
    label: { de: "Walnut Edition", en: "Walnut Edition", fr: "Walnut Edition", es: "Walnut Edition" },
    swatch: "linear-gradient(135deg, #6E4A36 0%, #563626 55%, #46291C 100%)",
    hex: "#5C4033",
    backdrop: "#EDE6DC",
    dark: false,
    desc: {
      de: "Dunkles Holz mit Tiefe – klassisch und hochwertig.",
      en: "Dark wood with depth – classic and refined.",
      fr: "Bois sombre et profond – classique et raffiné.",
      es: "Madera oscura con profundidad – clásica y refinada.",
    },
  },
  {
    code: "ivory",
    name: "Ivory",
    label: { de: "Ivory Edition", en: "Ivory Edition", fr: "Ivory Edition", es: "Ivory Edition" },
    swatch: "linear-gradient(135deg, #FFFFFF 0%, #F4F1EB 60%, #E9E4DB 100%)",
    hex: "#F5F2EC",
    backdrop: "#FFFFFF",
    dark: false,
    desc: {
      de: "Hell, ruhig und minimalistisch – für lichtdurchflutete Räume.",
      en: "Bright, calm and minimal – for light-filled spaces.",
      fr: "Lumineux, calme et minimaliste – pour les espaces baignés de lumière.",
      es: "Luminoso, sereno y minimalista – para espacios llenos de luz.",
    },
  },
  {
    code: "obsidian",
    name: "Obsidian",
    label: { de: "Obsidian Edition", en: "Obsidian Edition", fr: "Obsidian Edition", es: "Obsidian Edition" },
    swatch: "linear-gradient(135deg, #2A2A28 0%, #1C1C1A 55%, #0E0E0D 100%)",
    hex: "#1C1C1A",
    backdrop: "#2B2B29",
    dark: true,
    desc: {
      de: "Tiefes Schwarz – reduziert, dramatisch, architektonisch.",
      en: "Deep black – reduced, dramatic, architectural.",
      fr: "Noir profond – épuré, dramatique, architectural.",
      es: "Negro profundo – reducido, dramático, arquitectónico.",
    },
  },
  {
    code: "blush",
    name: "Blush",
    label: { de: "Blush Edition", en: "Blush Edition", fr: "Blush Edition", es: "Blush Edition" },
    swatch: "linear-gradient(135deg, #E8C9C4 0%, #D9AFA8 55%, #C99A93 100%)",
    hex: "#D9AFA8",
    backdrop: "#F4ECE9",
    dark: false,
    desc: {
      de: "Zarter, gedeckter Rosé-Ton – elegant und modern.",
      en: "Soft, muted rosé – elegant and modern.",
      fr: "Rosé doux et feutré – élégant et moderne.",
      es: "Rosa suave y apagado – elegante y moderno.",
    },
  },
];

export const DEFAULT_EDITION = "natural";
export const findEdition = (code) => EDITIONS.find((e) => e.code === code) || EDITIONS[0];

const HORNBEAM = { de: "Hainbuchenholz (Hornbeam Wood)", en: "Hornbeam wood", fr: "Bois de charme (Hornbeam)", es: "Madera de carpe (Hornbeam)" };

export const REFORMERS = [
  {
    slug: "classic-reformer",
    name: "Classic Reformer",
    shortName: "Classic",
    titleLines: ["CLASSIC", "REFORMER"],
    images: {
      natural: "/images/products/classic-natural.png",
      walnut: "/images/products/classic-walnut.png",
      ivory: "/images/products/classic-ivory.png",
      obsidian: "/images/products/classic-obsidian.png",
      blush: "/images/products/classic-blush.png",
    },
    desc: {
      de: "Der Klassiker. Ein massiver Rahmen aus Hainbuchenholz, klare Linien und ein leise gleitender Schlitten – reduziert auf das Wesentliche.",
      en: "The classic. A solid hornbeam frame, clean lines and a silent-gliding carriage – reduced to the essential.",
      fr: "Le classique. Un cadre en charme massif, des lignes épurées et un chariot silencieux – réduit à l'essentiel.",
      es: "El clásico. Un bastidor de carpe macizo, líneas claras y un carro silencioso – reducido a lo esencial.",
    },
    material: HORNBEAM,
    dims: "240 × 70 × 60 cm",
    price: null,
    editionPrices: {},
  },
  {
    slug: "tower-reformer",
    name: "Tower Reformer",
    shortName: "Tower",
    titleLines: ["TOWER", "REFORMER"],
    images: {
      natural: "/images/products/tower-natural.png",
      walnut: "/images/products/tower-walnut.png",
      ivory: "/images/products/tower-ivory.png",
      obsidian: "/images/products/tower-obsidian.png",
      blush: "/images/products/tower-blush.png",
    },
    desc: {
      de: "Reformer mit Tower-Aufsatz für einen erweiterten Übungsumfang – Kraft, Mobilität und Therapie auf kompakter Fläche.",
      en: "Reformer with tower attachment for an extended exercise range – strength, mobility and therapy on a compact footprint.",
      fr: "Reformer avec tour pour un répertoire d'exercices élargi – force, mobilité et thérapie sur une surface compacte.",
      es: "Reformer con torre para un repertorio de ejercicios ampliado – fuerza, movilidad y terapia en una superficie compacta.",
    },
    material: HORNBEAM,
    dims: "240 × 85 × 197 cm",
    price: null,
    editionPrices: {},
  },
  {
    slug: "combo-cadillac-reformer",
    name: "Combo Cadillac Reformer",
    shortName: "Cadillac",
    titleLines: ["COMBO CADILLAC", "REFORMER"],
    images: {
      natural: "/images/products/cadillac-natural.png",
      walnut: "/images/products/cadillac-walnut.png",
      ivory: "/images/products/cadillac-ivory.png",
      obsidian: "/images/products/cadillac-obsidian.png",
      blush: "/images/products/cadillac-blush.png",
    },
    desc: {
      de: "Die Kombination aus Reformer und Cadillac – maximale Vielseitigkeit für professionelle Studios.",
      en: "The combination of reformer and cadillac – maximum versatility for professional studios.",
      fr: "La combinaison du Reformer et du Cadillac – une polyvalence maximale pour les studios professionnels.",
      es: "La combinación de Reformer y Cadillac – máxima versatilidad para estudios profesionales.",
    },
    material: HORNBEAM,
    dims: "240 × 85 × 197 cm",
    price: null,
    editionPrices: {},
  },
];

export const EQUIPMENT = [
  {
    slug: "ladder-barrel",
    name: "Ladder Barrel",
    image: "/images/products/ladder-barrel.png",
    backdrop: "#F3EFEA",
    desc: {
      de: "Ergonomischer Bogen mit Leiter für Rumpfstreckung, Mobilisation und Dehnung.",
      en: "Ergonomic barrel with ladder for extension, mobilisation and stretching.",
      fr: "Baril ergonomique avec échelle pour l'extension, la mobilisation et l'étirement.",
      es: "Barril ergonómico con escalera para extensión, movilización y estiramiento.",
    },
    material: { de: "Holz · Polsterung", en: "Wood · upholstery", fr: "Bois · rembourrage", es: "Madera · tapicería" },
    dims: null,
    price: null,
  },
  {
    slug: "combo-chair",
    name: "Combo Chair",
    image: "/images/products/combo-chair.png",
    backdrop: "#EDE6DC",
    desc: {
      de: "Kompakter Stuhl mit Pedal und Griffen für funktionelles Kraft- und Balancetraining.",
      en: "Compact chair with pedal and handles for functional strength and balance work.",
      fr: "Chaise compacte avec pédale et poignées pour un travail fonctionnel de force et d'équilibre.",
      es: "Silla compacta con pedal y asas para trabajo funcional de fuerza y equilibrio.",
    },
    material: { de: "Holz · Polsterung · Metall", en: "Wood · upholstery · metal", fr: "Bois · rembourrage · métal", es: "Madera · tapicería · metal" },
    dims: null,
    price: null,
  },
  {
    slug: "springwall",
    name: "Springwall",
    image: "/images/products/springwall.png",
    backdrop: "#F3EFEA",
    desc: {
      de: "Platzsparendes Wand-Federsystem für vielseitiges Widerstandstraining.",
      en: "Space-saving wall-mounted spring system for versatile resistance training.",
      fr: "Système mural à ressorts peu encombrant pour un entraînement en résistance polyvalent.",
      es: "Sistema mural de resortes que ahorra espacio para un entrenamiento de resistencia versátil.",
    },
    material: { de: "Holz · Federn · Metall", en: "Wood · springs · metal", fr: "Bois · ressorts · métal", es: "Madera · resortes · metal" },
    dims: null,
    price: null,
  },
  {
    slug: "spine-corrector",
    name: "Spine Corrector",
    image: "/images/products/spine-corrector.jpg",
    backdrop: "#161615",
    dark: true,
    cover: true,
    desc: {
      de: "Mobiler Bogen für Alignment, Wirbelsäulenmobilisation und regenerative Arbeit.",
      en: "Portable arc for alignment, spinal mobilisation and restorative work.",
      fr: "Arc mobile pour l'alignement, la mobilisation vertébrale et le travail régénérant.",
      es: "Arco portátil para alineación, movilización vertebral y trabajo regenerativo.",
    },
    material: { de: "Polsterung", en: "Upholstery", fr: "Rembourrage", es: "Tapicería" },
    dims: null,
    price: null,
  },
];

// Belegbare Qualitätsmerkmale aus dem Produktkatalog
export const CRAFT = {
  wood: {
    stat: "30 MM",
    title: { de: "SOLID HORNBEAM WOOD", en: "SOLID HORNBEAM WOOD", fr: "SOLID HORNBEAM WOOD", es: "SOLID HORNBEAM WOOD" },
    text: {
      de: "Massives Hainbuchenholz in 30 mm Stärke und A/A-Qualität bildet die Basis unserer Holz-Reformer – es verbindet hohe Stabilität mit einer natürlichen, hochwertigen Ästhetik.",
      en: "Solid hornbeam wood, 30 mm thick in A/A quality, forms the foundation of our wooden reformers – combining strength with a natural, refined aesthetic.",
      fr: "Du bois de charme massif de 30 mm en qualité A/A constitue la base de nos Reformers en bois – alliant stabilité et esthétique naturelle et raffinée.",
      es: "Madera de carpe maciza de 30 mm en calidad A/A forma la base de nuestros Reformers de madera – uniendo estabilidad con una estética natural y refinada.",
    },
    image: "/images/products/detail-wood.jpg",
  },
  joinery: {
    title: { de: "VERBINDUNGEN OHNE SCHRAUBEN", en: "JOINERY WITHOUT SCREWS", fr: "ASSEMBLAGES SANS VIS", es: "UNIONES SIN TORNILLOS" },
    text: {
      de: "Die Holzverbindungen unserer Rahmen kommen ohne Schrauben aus: Zusätzliche, in das Holz gefräste Kanäle werden mit Marine-Leim dauerhaft verbunden.",
      en: "Our frame joints are made without screws: additional channels milled into the wood are permanently bonded with marine-grade glue.",
      fr: "Les assemblages de nos cadres se font sans vis : des rainures supplémentaires fraisées dans le bois sont collées durablement à la colle marine.",
      es: "Las uniones de nuestros bastidores se realizan sin tornillos: canales adicionales fresados en la madera se unen de forma permanente con cola marina.",
    },
    image: "/images/products/detail-metal.jpg",
  },
  upholstery: {
    title: { de: "UPHOLSTERY", en: "UPHOLSTERY", fr: "UPHOLSTERY", es: "UPHOLSTERY" },
    sub: { de: "MADE FOR MOVEMENT.", en: "MADE FOR MOVEMENT.", fr: "MADE FOR MOVEMENT.", es: "MADE FOR MOVEMENT." },
    points: {
      de: [
        "Speziell gefertigter Schaumkern, der ein Einsinken der Polsterung verhindert",
        "Schweiß- und feuchtigkeitsresistentes Bezugsmaterial",
        "Vierseitige Ziernaht",
      ],
      en: [
        "Specially produced foam core that prevents the upholstery from collapsing",
        "Sweat- and moisture-resistant cover material",
        "Four-sided stitching",
      ],
      fr: [
        "Noyau en mousse spécialement fabriqué qui empêche l'affaissement du rembourrage",
        "Revêtement résistant à la transpiration et à l'humidité",
        "Surpiqûre sur quatre côtés",
      ],
      es: [
        "Núcleo de espuma fabricado especialmente que evita el hundimiento de la tapicería",
        "Revestimiento resistente al sudor y a la humedad",
        "Costura decorativa en cuatro lados",
      ],
    },
    image: "/images/products/detail-upholstery.jpg",
  },
};

export const ALL_PRODUCTS = [...REFORMERS, ...EQUIPMENT];

const LEGACY_SLUGS = { classic: "classic-reformer", tower: "tower-reformer", cadillac: "combo-cadillac-reformer" };
export const resolveSlug = (slug) => LEGACY_SLUGS[slug] || slug;
export const findProduct = (slug) => ALL_PRODUCTS.find((p) => p.slug === resolveSlug(slug));
export const isReformer = (slug) => REFORMERS.some((p) => p.slug === resolveSlug(slug));
export const productImage = (p, edition = DEFAULT_EDITION) =>
  p.images ? p.images[edition] || p.images[DEFAULT_EDITION] : p.image;
